<ng-container *ngIf="!isMobile">
  <div
    class="border border-solid border-blue-200 hidden md:block w-[400px] top-[100%] left-0 z-50 absolute bg-white px-[20px] py-[24px] rounded-2xl"
    id="reserve-card">
    <div class="flex justify-between w-full">
      <h4 class="text-lg !font-extrabold text-black-500">یادآوری رزرو</h4>
      <i class="ico-Close !font-bold" (click)="closeCard()"></i>
    </div>

    <p *ngIf="latestActiveReserve.reserveStatusId == 107" class="text-base text-black-400">رزرو شما در مرحله واریز وجه
      قرار دارد. مایل به ادامه دادن آخرین رزرو خود هستید؟</p>
    <p class="text-base text-black-400" *ngIf="latestActiveReserve.reserveStatusId == 112">رزرو شما در مرحله “انتظار
      پاسخ
      هتل” می باشد. مایل به ادامه دادن آخرین رزرو خود هستید؟</p>
    <div class="w-full flex justify-between border border-bottom pb-3 my-2">
      <p class="text-base !font-medium text-primary" style="color: #0969DA;">{{latestActiveReserve?.hotelName}}</p>
      <p class="flex items-center" [innerHTML]="displayTimer"></p>
    </div>
    <div class="w-full flex justify-between">
      <p class="">
        <span class="text-black-300 text-sm font-normal">پرداخت : </span>
        <span class="text-lg text-black-500 !font-medium">{{latestActiveReserve?.reserveCost| toToman | number:
          '2.'}}</span>
        <span class="text-black-300 text-sm font-normal"> تومان </span>
      </p>
      <a (click)="proceedReserve()" [href]="latestActiveReserve.reserveTrackingLink" target="_blank"
        class="px-[30px] py-[10px]  bg-blue-500 rounded-lg font-semibold text-sm text-white hover:bg-blue-600 duration-100 transition-all">
        ادامه رزرو
      </a>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="isMobile">
  <div class="w-full left-0 z-10 fixed bg-[#FFEFCB] px-[20px] h-[50px] mobile-last-card">
    <div class="flex w-full justify-between items-center mt-[10px]">
      <div class="flex">
        <i class="ico-Close !font-bold ml-2" (click)="closeCard()"></i>
        <p class="text-xs !font-medium">شما یک رزرو در حال انجام دارید.</p>
      </div>
      <a (click)="proceedReserve()" [href]="latestActiveReserve.reserveTrackingLink" target="_blank"
        class="px-[10px] py-[2px] flex items-center  bg-[#FFB500] rounded-lg font-semibold text-sm text-black  duration-100 transition-all">
        ادامه رزرو
    <i class="ico-Left !font-bold text-xl"></i>
      </a>
    </div>
  </div>
</ng-container>
